import React,{useState} from 'react';
import './Footer.css';
import {Link} from 'react-router-dom';
function Footer() {
  const[till,setTill]=useState(new Date().getFullYear());
  return <div className='footer'>
   <a className='first__anchor' href="#">
   <div className='first__component'>
      Back to top
   </div>
   </a>

   <div className='second__component'>
    
    <div className='second__componentcontent'>
     <h4>Get to know us</h4>
     <p>About us</p>
     <p>Career</p>
     <p>Press Releases</p>
     <p>Amazon Cares</p>
     <p>Gift a Smile</p>
     <p>Amazon Science</p>
    </div>
    <div className='second__componentcontent'>
    <h4>connect with Us</h4>
     <p>facebook</p>
     <p>twitter</p>
     <p>Instagram</p>
    </div>
    <div className='second__componentcontent'>
    <h4>Make Money with Us</h4>
     <p>Sell on Amazon</p>
     <p>Send under Amazon Accelerator</p>
     <p>Amazon Global Selling</p>
     <p>Become a affiliate</p>
     <p>fulFillment by Amazon</p>
     <p>Advertise your product</p>
     <p>Amazon product on merchent</p>
    </div>
    <div className='second__componentcontent'>
     <h4>Let Us help You</h4>
     <p>COVID-19 and Amazon</p>
     <p>Your Account</p>
     <p>Return Centre</p>
     <p>100% Purchase Protection</p>
     <p>Amazon App Download</p>
     <p>Amazon Assistant Download</p>
     <p>Help</p>
    </div>
   
   </div>
   <div className='third__component'>
    <div className='third1__component'>
    <img
     className="footer__logo"
      href="http://pngimg.com/uploads/amazon/amazon_PNG11.png"
      />
    </div>

    <div className='third2__component'>
      <p><a href="https://www.amazon.com.au/ref=footer_au">Australia</a></p>
      <p><a href="https://www.amazon.com.br/ref=footer_br">Brazil</a></p>
      <p><a href="https://www.amazon.ca/ref=footer_ca">Canada</a></p>
      <p><a href="https://www.amazon.cn/ref=footer_cn">China</a></p>
      <p><a href="https://www.amazon.fr/ref=footer_fr">France</a></p>
      <p><a href="https://www.amazon.de/ref=footer_de">Germany</a></p>
      <p><a href="https://www.amazon.it/ref=footer_it">Italy</a></p>
      <p><a href="https://www.amazon.com.mx/ref=footer_mx">japan</a></p>
      <p><a href="https://www.amazon.com.mx/ref=footer_mx">Mexio</a></p>
      <p><a href="https://www.amazon.nl/ref=footer_nl">Nehterland</a></p>
      <p><a href="https://www.amazon.sg/ref=footer_sg">poland</a></p>
      <p><a href="https://www.amazon.sg/ref=footer_sg">Singapore</a></p>
      <p><a href="https://www.amazon.es/ref=footer_es">Spain</a></p>
      <p><a href="https://www.amazon.com.tr/ref=footer_tr">Turkey</a></p>
      <p><a href="https://www.amazon.ae/ref=footer_ae">United Arab Amirates</a></p> 
    </div>
    <div className='third2__component'>
    <p><a href="https://www.amazon.co.uk/ref=footer_uk">United Kingdom</a></p>
      <p><a href="https://www.amazon.com/ref=footer_us">United State</a></p>
    </div>
   </div>
   <div className='fourth__component'>
     <div className='fourth1__component'>
     <div>
     <div className='fourth2__component'>
      <a href="https://www.abebooks.com/">
      <h5>AbeBooks</h5>
      <p>Book art &</p>
      <p>collection</p>
      </a>
     </div>
     <div className='fourth2__component'>
      <a href="https://www.abebooks.com/">
      <h5>Amazon Web Service</h5>
      <p>Scalable cloud</p>
      <p>Computing Service</p>
      </a>
     </div>
     </div>
      
     <div>
     <div className='fourth2__component'>
      <a href="https://www.audible.in/">
      <h5>Audible</h5>
      <p>Downloads</p>
      <p>Audio Books</p>
      </a>
     </div>
     <div className='fourth2__component'>
      <a href="https://www.dpreview.com/">
      <h5>DPReview</h5>
      <p>digital</p>
      <p>Photography</p>
      </a>
     </div>
     </div>

     <div>
     <div  className='fourth2__component'>
      <a href="https://www.imdb.com/">
      <h5>IMDB</h5>
      <p>Movie TV &</p>
      <p>Celebrities</p>
      </a>
     </div>
     <div className='fourth2__component'>
       <a href="https://www.shopbop.com/">
       <h5>ShopBop</h5>
       <p>Designer</p>
       <p>Fashion Brands</p>
       </a>
     </div>
     </div>
      
     <div>
     <div className='fourth2__component'>
       <a href="https://www.amazon.in/l/21102587031?ref=footer_aingw">
       <h5>Amazon Business</h5>
       <p>Everythings for</p>
       <p>Your business</p>
       </a>
     </div> 
     <div className='fourth2__component'>
       <a href="https://www.amazon.in/l/8557209031?ref=footer_amznow">
       <h5>Prime Now</h5>
       <p>2-hours delivery</p>
       <p>On daily Item</p>
       </a>
     </div>
     </div>

     <div>
     <div className='fourth2__component'>
       <a href="https://www.amazon.in/music/prime?ref=footer_apm">
       <h5>Amazon Prime Music</h5>
       <p>75 millions songs,ad-freee</p>
       <p>Over 10 million Podcosts</p>
       </a>
     </div>
     </div> 
    </div>
    <div className='fourth3__component'>
    Conditions of UsePrivacy NoticeInterest-Based Ads© 1996-{till}, Amazon.com, Inc. or its affiliates
    </div>
   </div>
  </div>;
}

export default Footer;
